import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { TEXTS } from "@/data/texts";

const LangContext = createContext({ lang: "it", t: TEXTS.it, toggle: () => {} });

const getInitialLang = () => {
  if (typeof window === "undefined") return "it";
  const saved = localStorage.getItem("simono_lang");
  if (saved === "it" || saved === "en") return saved;
  const nav = (navigator.language || "it").toLowerCase();
  return nav.startsWith("en") ? "en" : "it";
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    localStorage.setItem("simono_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "it" ? "en" : "it")), []);

  const value = useMemo(
    () => ({ lang, t: TEXTS[lang], toggle }),
    [lang, toggle],
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
